import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { DropdownButton } from '../../Dropdown/DropdownButton.js';
import { useMenuButton } from '../useMenuButton/useMenuButton.js';

var MenuButton = function (props) {
    var menuButtonProps = useMenuButton().props;
    return jsx(DropdownButton, __assign({}, menuButtonProps, props));
};

export { MenuButton };
//# sourceMappingURL=MenuButton.js.map
